import "./App.css";
import "./styles/Footer.css";
import "./styles/Header.css";
import "./styles/MainBody.css";
import "./styles/admin.css";
import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import CartPage from "./pages/cart-page/CartPage";
import ProductPage from "./pages/product-page/ProductPage";
import CatalogPage from "./pages/catalog/CatalogPage";
import FilterContextProvider from "./Context/FilterContext";
import ToggleNavBar from "./Components/Header/ToggleNavBar";
import DataContextProvider from "./Context/DataContext";
import ScrollToTop from "./ScrollToTop";
import SignUp from "./pages/authentication/signup/SignUp";
import LogIn from "./pages/authentication/Log-In/LogIn";
import { useDispatch, useSelector } from "react-redux";
import { checkIsAuthenticated } from "./store/user/UserActions";
import Activate from "./pages/authentication/signup/Activate";
import ResetPassword from "./pages/authentication/Log-In/ResetPassword";
import ResetPasswordConfirm from "./pages/authentication/Log-In/ResetPasswordConfirm";
import PageNotFound from "./PageNotFound";
import { fetchCart } from "./store/cart/CartActions";
import AboutUs from "./pages/AboutUs/AboutUs";
import AdminDashboard from "./pages/admintwo/AdminDashboard";
import ListProducts from "./pages/admintwo/products/ListProducts";
import ListCategories from "./pages/admintwo/categories/ListCategories";
import AddEditCategory from "./pages/admintwo/categories/AddEditCategory";
import ToggleFooter from "./Components/Footer/ToggleFooter";
import AddEditProduct from "./pages/admintwo/products/AddEditProduct";
import ListCustomers from "./pages/admintwo/customers/ListCustomers";
import NotificationPopup from "./methods/showNotificationGlobal";
import CustomerOrders from "./pages/admintwo/orders/CustomerOrders";
import CustomerCart from "./pages/admintwo/orders/CustomerCart";
import SendMail from "./pages/admintwo/customers/SendMail";
import AllOrders from "./pages/admintwo/orders/AllOrders";
import CustomerOrderDetail from "./pages/admintwo/orders/CustomerOrderDetail";
import SendMassMail from "./pages/admintwo/customers/SendMassMail";
import CheckOut from "./pages/checkout/CheckOut";
import MyOrders from "./pages/orders/MyOrders";

function App() {
  const dispatch = useDispatch();

  const { is_staff } = useSelector((state) => state.user?.user ?? false);

  useEffect(() => {
    dispatch(checkIsAuthenticated()).then((_) => {
      dispatch(fetchCart());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <DataContextProvider>
        <FilterContextProvider>
          <Router>
            <ScrollToTop />
            <ToggleNavBar></ToggleNavBar>
            <NotificationPopup />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cart" element={<CartPage />} />
              <Route exact path="/checkout/" element={<CheckOut />} />
              <Route exact path="/orders/" element={<MyOrders />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route
                exact
                path="/product/:productname"
                element={<ProductPage />}
              />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route exact path="/login" element={<LogIn />} />
              <Route exact path="/signup" element={<SignUp />} />
              {/* React router does partial matching, so /users partially matches /users/create, so it would incorrectly return the Users route again! The exact param disables the partial matching for a route and makes sure that it only returns the route if the path is an EXACT match to the current url. */}
              <Route
                exact
                path="/activate/:uid/:token"
                element={<Activate />}
              />
              <Route exact path="/reset_password" element={<ResetPassword />} />
              <Route
                exact
                path="/password/reset/confirm/:uid/:token"
                element={<ResetPasswordConfirm />}
              />
              {/* <Route exact path="/admin/" element={<AdminPage />} />
              
              {is_staff && (
                <>
                  <Route exact path="/admin/:nm" element={<AdminPage />} />
                  <Route
                    exact
                    path="/admin/:nm/add/"
                    element={<AdminPage addItem={true} />}
                  />
                  <Route
                    exact
                    path="/admin/:nm/:pk"
                    element={<AdminPage changeItem={true} />}
                  />
                </>
              )} */}
              {/* admin two */}
              <Route exact path="/admin/" element={<AdminDashboard />} />
              {is_staff && (
                <>
                  <Route
                    exact
                    path="/admin/products"
                    element={<ListProducts />}
                  />
                  <Route
                    exact
                    path="/admin/products/add"
                    element={<AddEditProduct />}
                  />
                  <Route
                    exact
                    path="/admin/products/:pk"
                    element={<AddEditProduct />}
                  />
                  <Route
                    exact
                    path="/admin/categories"
                    element={<ListCategories />}
                  />
                  <Route
                    exact
                    path="/admin/categories/add"
                    element={<AddEditCategory />}
                  />
                  <Route
                    exact
                    path="/admin/categories/:pk"
                    element={<AddEditCategory />}
                  />
                  <Route
                    exact
                    path="/admin/customers"
                    element={<ListCustomers />}
                  />

                  <Route exact path="/admin/orders" element={<AllOrders />} />
                  <Route
                    exact
                    path="/admin/orders/order/:id"
                    element={<CustomerOrderDetail />}
                  />
                  <Route
                    exact
                    path="/admin/orders/:pk"
                    element={<CustomerOrders />}
                  />

                  <Route
                    exact
                    path="/admin/cart/:pk"
                    element={<CustomerCart />}
                  />
                  <Route exact path="/admin/mail/:pk" element={<SendMail />} />
                  <Route
                    exact
                    path="/admin/campaign/"
                    element={<SendMassMail />}
                  />
                </>
              )}
              <Route exact path="/:category" element={<Home />} />
              <Route exact path="*" element={<PageNotFound />} />
            </Routes>
            {/* Footer to be accessible in all pages expect admin*/}
            <ToggleFooter />
            {/* <Footer /> */}
          </Router>
        </FilterContextProvider>
      </DataContextProvider>
    </div>
  );
}

export default App;
